// P0 reads a connector's Cloud Run service (run.services.get) to get its URL
// when it installs. roles/run.invoker lacks that permission, so P0's service
// account also needs roles/run.viewer on the service.

type CloudRunViewerShellParams = {
  service: string;
  projectId: string;
  region: string;
  /** The service account email. */
  member: string;
};

type CloudRunViewerTfParams = {
  /** The Terraform resource name, a bare identifier. */
  resource: string;
  /** An HCL expression, inserted verbatim (e.g. a quoted literal or a reference). */
  project: string;
  /** An HCL expression, inserted verbatim. */
  location: string;
  /** The Cloud Run service's name, as an HCL expression inserted verbatim. */
  service: string;
  /** The service account email as it appears inside an HCL string: a literal
   * email or an HCL interpolation. */
  member: string;
};

/**
 * A gcloud command that grants P0's service account roles/run.viewer on a
 * Cloud Run service. All arguments are plain strings.
 */
export const cloudRunViewerShell = (params: CloudRunViewerShellParams) => {
  const { service, projectId, region, member } = params;
  return `gcloud run services add-iam-policy-binding ${service} \\
  --project=${projectId} \\
  --region=${region} \\
  --member="serviceAccount:${member}" \\
  --role="roles/run.viewer"`;
};

/**
 * A Terraform resource that grants P0's service account roles/run.viewer on a
 * Cloud Run service. `project`, `location` and `service` are HCL expressions;
 * `member` is the content of an HCL string.
 */
export const cloudRunViewerTf = (params: CloudRunViewerTfParams) => {
  const { resource, project, location, service, member } = params;
  return `# P0 reads the service to get its invocation URL when it installs.
resource "google_cloud_run_v2_service_iam_member" "${resource}" {
  project  = ${project}
  location = ${location}
  name     = ${service}
  role     = "roles/run.viewer"
  member   = "serviceAccount:${member}"
}`;
};
